export default __webpack_public_path__ + "static/media/Museo700-Regular.a870a5a3.ttf";